import React, {useEffect, useState} from 'react';
import {withFormik} from 'formik';
import {isValidPhoneNumber} from 'react-phone-number-input';
import * as Yup from 'yup';
import Icon from 'react-icons-kit';
import {locked} from 'react-icons-kit/iconic/locked';
import {analytics} from '../../helpers/firebaseHelper';
import Translate from '../../helpers/translateHelper';
import Text from 'reusecore/src/elements/Text';
import Button from 'reusecore/src/elements/Button';
import AuthHeader from '../../components/AuthHeader';
import Input from '../../components/Input';
import Box from 'reusecore/src/elements/Box';
import {FormGroup, ErrorNotification} from '../SignInForm/style';
import {REGISTER} from '@core/ui/graphql/Mutations';
import {useMutation} from '@apollo/client';
import AuthHelper from '../../helpers/authHelper';
import {Modal, openModal} from '@redq/reuse-modal';
import CguModal from '../ModalContainer/CguModal';
import Checkbox from 'reusecore/src/elements/Checkbox';
import TextButton from '../../components/TextButton';
import signUpModalSuccess from '../ModalContainer/SuccessModal/signUp';
import Link from 'next/link';
import Select from 'reusecore/src/elements/Select';
import inputSelectStyles from '../AddPost/Styles/InputSelectStyles';
import {useTranslation} from 'next-i18next';
import {useRouter} from 'next/router';

const SignupEnhancher = withFormik({
  enableReinitialize: true,
  mapPropsToValues: props => ({
    mail: '',
    password: '',
    mobile: '',
    prenom: '',
    name: '',
    alternateName: '',
    lang: null,
  }),
  validationSchema: Yup.object().shape({
    mail: Yup.string()
      .email('validation.mail.invalid')
      .required('validation.missing'),
    password: Yup.string().required('validation.password.missing'),
    prenom: Yup.string()
      .matches(/.{2,}/, {message: 'validation.firstname.invalid'})
      .required('validation.missing'),
    name: Yup.string()
      .matches(/.{2,}/, {message: 'validation.lastname.invalid'})
      .required('validation.missing'),
    alternateName: Yup.string()
      .matches(/.{2,}/, {message: 'validation.firstname.invalid'})
      .required('validation.missing'),
    mobile: Yup.string().test({
      name: 'validPhoneNumber',
      message: 'validation.mobile.invalid',
      test: value => (!!value ? isValidPhoneNumber(value) : true),
    }),
    lang: Yup.string().required('validation.missing'),
  }),
});
let token = '';
const SignUpForm = ({
                      values,
                      touched,
                      errors,
                      handleChange,
                      handleSubmit,
                      handleBlur,
                      setFieldValue,
                      resetForm,
                      setFieldTouched,
                      callback,
                      fromDraft
                    }) => {
    const [error, setError] = useState({});
    const [loading, setLoading] = useState(true);
    const [cgu, setCgu] = useState(false);

    const {t} = useTranslation();

    const {locale, locales} = useRouter();

    handleSubmit = async () => {
      setFieldTouched('mail', true);
      setFieldTouched('password', true);
      setFieldTouched('name', true);
      setFieldTouched('prenom', true);
      setFieldTouched('alternateName', true);
      setFieldTouched('mobile', true);
      setFieldTouched('lang', true);
      setLoading(true);
      if (!Object.keys(errors).length) {
        if (!cgu) {
          setError({
            message: t('signup.terms.error'),
          });
          setLoading(false);
          return;
        }
        const {mail, password, lang} = values;
        const provider = 'password';

        let res;
        try {
          res = await registerMutation();
        } catch (e) {
          setLoading(false);
          setError({
            message: e.message,
          });
          return;
        }

        const {user, error} = await AuthHelper.setLang(lang.value).signUp(
          provider,
          mail,
          password
        );

        if (error) {
          setLoading(false);
          const message = Translate(error.message);
          setError({
            message: message ? message : error.message,
          });
        } else {
          token = await user.getIdToken();
          setFieldValue('token', token);

          // add analytics signup event
          if (typeof window !== 'undefined' && analytics) {
            analytics.logEvent('sign_up', {method: provider});
          }

          const {
            data: {register},
          } = res;


          if (register) {
            if (callback) {
              callback(user, {
                id: user.uid,
                mail: values.mail,
                mobile: values.mobile,
                prenom: values.prenom,
                name: values.name,
                alternateName: values.alternateName,
                lang: values.lang?.value,
              });
              resetForm();
            } else {
              openModal({
                config: {
                  height: 450,
                  width: 500,
                  disableDragging: true,
                  transition: {
                    tension: 150,
                  },
                },
                modalClass: 'customModal',
                closeOnClickOutside: true,
                component: signUpModalSuccess,
                componentProps: {
                  user: res,
                },
              });
            }
            resetForm();
          }
        }
        setLoading(false);
      } else {
        setLoading(false);
      }
    };

    const [registerMutation] = useMutation(REGISTER, {
      variables: {
        user: {
          mail: values.mail,
          token: values.token,
          mobile: values.mobile,
          prenom: values.prenom,
          name: values.name,
          alternateName: values.alternateName,
          lang: values.lang?.value,
        },
      },
    });

    useEffect(() => {
      // set default lang
      values.lang = {value: locale, label: t('lang.' + locale)};

      setLoading(false);
    }, []);

    return (
      <>
        {/* auth page header section */}
        {
          !fromDraft && (
            <AuthHeader/>
          )
        }
        <Modal/>

        {/* signup form */}
        <FormGroup className={errors.mail ? 'hasErrorMsg' : ''}>
          <Input
            elementType="input"
            elementConfig={{
              type: 'email',
              required: 'required',
            }}
            value={values.mail}
            error={errors.mail}
            touched={touched.mail}
            label={t(`Email`) + '*'}
            onBlur={() => setFieldTouched('mail', true)}
            changed={handleChange('mail')}
            highlightColor="#f09"
          />
          <span className="errorMsg">
          {errors.mail && touched.mail && t(errors.mail)}
        </span>
        </FormGroup>
        <FormGroup className={errors.prenom ? 'hasErrorMsg' : ''}>
          <Input
            elementType="input"
            elementConfig={{
              type: 'text',
              required: 'required',
            }}
            value={values.prenom}
            error={errors.prenom}
            touched={touched.prenom}
            label={t('firstname') + '*'}
            onBlur={() => setFieldTouched('prenom', true)}
            changed={handleChange('prenom')}
            highlightColor="#f09"
          />
          <span className="errorMsg">
          {errors.prenom && touched.prenom && t(errors.prenom)}
        </span>
        </FormGroup>
        <FormGroup className={errors.name ? 'hasErrorMsg' : ''}>
          <Input
            elementType="input"
            elementConfig={{
              type: 'text',
              required: 'required',
            }}
            value={values.name}
            error={errors.name}
            touched={touched.name}
            label={t('lastname') + '*'}
            onBlur={() => setFieldTouched('name', true)}
            changed={handleChange('name')}
            highlightColor="#f09"
          />
          <span className="errorMsg">
          {errors.name && touched.name && t(errors.name)}
        </span>
        </FormGroup>
        <FormGroup className={errors.alternateName ? 'hasErrorMsg' : ''}>
          <Input
            elementType="input"
            elementConfig={{
              type: 'text',
              required: 'required',
            }}
            value={values.alternateName}
            error={errors.alternateName}
            touched={touched.alternateName}
            label={t('alternateName') + '*'}
            onBlur={() => setFieldTouched('alternateName', true)}
            changed={handleChange('alternateName')}
            highlightColor="#f09"
          />
          <span className="errorMsg">
          {errors.alternateName &&
            touched.alternateName &&
            t(errors.alternateName)}
        </span>
        </FormGroup>
        <FormGroup className={errors.mobile ? 'hasErrorMsg' : ''}>
          <Input
            elementType="phone"
            value={values.mobile}
            error={errors.mobile}
            touched={touched.mobile}
            label={t('mobile')}
            onBlur={() => setFieldTouched('mobile', true)}
            changed={handleChange('mobile')}
            highlightColor="#f09"
            elementConfig={{
              type: 'phone',
              name: 'phone',
              value: values.phone,
            }}
          />
          <span className="errorMsg">
          {errors.mobile && touched.mobile && t(errors.mobile)}
        </span>
        </FormGroup>
        <FormGroup className={errors.password ? 'hasErrorMsg' : ''}>
          <Input
            elementType="input"
            elementConfig={{
              type: 'password',
              required: 'required',
            }}
            value={values.password}
            error={errors.password}
            onBlur={() => setFieldTouched('password', true)}
            touched={touched.password}
            label={t('Password') + '*'}
            changed={handleChange('password')}
          />
          <span className="errorMsg">
          {errors.password && touched.password && t(errors.password)}
        </span>
        </FormGroup>
        {locales && locales.length > 1 && (
          <FormGroup
            className={errors.lang ? 'hasErrorMsg' : ''}
            style={{marginBottom: '2rem'}}
          >
            <Select
              aria-label={t('lang.placeholder')}
              placeholder={t('lang.placeholder')}
              noOptionsMessage={() => t('search.sidebar.empty')}
              onChange={handleChange('lang')}
              defaultValue={values.lang ? values.lang : []}
              value={values.lang ? values.lang : []}
              options={locales.map(lang => ({
                value: lang,
                label: t('lang.' + lang),
              }))}
              theme={theme => ({
                ...theme,
                borderRadius: 0,
                colors: {
                  ...theme.colors,
                  primary25: '#dcf5f9',
                  primary: '#dcf5f9',
                },
              })}
              styles={inputSelectStyles}
            />
          </FormGroup>
        )}

        <TextButton
          title={
            <span
              style={{
                marginLeft: -7,
                textDecoration: 'underline',
                color: '#333333!important',
              }}
            >
            {t('signin.termsLink')}
          </span>
          }
          iconPosition="left"
          icon={
            <Checkbox
              checked={cgu}
              value={'cgu'}
              onChange={val => {
                if (!cgu) {
                  setCgu(true);
                } else {
                  setCgu(false);
                }
              }}
              labelText={
                <span
                  style={{
                    fontSize: 12,
                    fontWeight: 600,
                    fontFamily: 'Poppins',
                    position: 'relative',
                    top: -1,
                  }}
                >
                {t('signin.terms')}
              </span>
              }
            />
          }
          onClick={() => {
            openModal({
              config: {
                maxWidth: '400px',
                maxHeight: '200px',
                width: '80%',
                height: '80%',
                disableDragging: true,
                transition: {
                  tension: 150,
                },
                enableResizing: {
                  bottom: true,
                  bottomLeft: true,
                  bottomRight: true,
                  left: true,
                  right: true,
                  top: true,
                  topLeft: true,
                  topRight: true,
                },
              },
              springStyle: {
                backgroundColor: '#ffffff',
                overflowY: 'auto',
                height: '100%',
                border: 'none',
              },
              component: CguModal,
              closeOnClickOutside: true,
            });
          }}
          className="md-hidden"
          style={{fontSize: 12}}
        />
        {error.message ? (
          <Box
            flexBox
            mt={20}
            mb={15}
            justifyContent="center"
            alignItems="center"
          >
            <ErrorNotification>{error.message}</ErrorNotification>
          </Box>
        ) : (
          ''
        )}
        <Button
          onClick={handleSubmit}
          title={t('signin.register')}
          width={1}
          className={'primary'}
          isLoading={loading}
          loaderColor="#fff"
          icon={<Icon icon={locked} size={21}/>}
          mt={20}
        />
        {
          !fromDraft && (
            <>
              <Box flexBox mt={20} justifyContent="center" alignItems="center">
                <Text content={t('signup.login')} color="#8C8C8C" mb="0"/>
                <Link href={`/signin`}>
                  <a style={{marginLeft: '10px'}}>{t('login')}</a>
                </Link>
              </Box>
              <p style={{textAlign: 'right'}}>
                <small style={{color: '#8C8C8C'}}>* {t('signin.required')}</small>
              </p>
            </>
          )
        }
      </>
    );
  }
;

export default SignupEnhancher(SignUpForm);
